import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://enhsjjnclwvgbwmjsckn.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVuaHNqam5jbHd2Z2J3bWpzY2tuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxNzMyMzMsImV4cCI6MjA5Mzc0OTIzM30.v88L-4TfWuSqSdlTdhmwIwb9V4ZboJWwxiR0ofj57-4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
